<script setup lang="ts">


const { getTeam } = useSchool()
// Use lazy: true to avoid blocking navigation/rendering if parent has no Suspense
const { data: team, status, error } = await useAsyncData('school-team', () => getTeam(), { lazy: true })

if (error.value) {
  console.error('SchoolTeam Error:', error.value)
}

const { elementRef: sectionRef, isVisible: isVisible } = useScrollReveal()

const flippedMemberId = ref<string | number | null>(null)

const toggleFlip = (memberId: string | number) => {
    if (flippedMemberId.value === memberId) {
        flippedMemberId.value = null
    } else {
        flippedMemberId.value = memberId
    }
}
</script>

<template>
  <section id="equipe" ref="sectionRef" class="py-32 bg-background text-foreground overflow-hidden relative transition-colors duration-300">
    <div class="container mx-auto px-6 relative z-10">
      <div class="text-center max-w-3xl mx-auto mb-24 transition-all duration-1000" :class="isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'">
        <UiSectionHeader 
          titlePrefix="Des experts passionnés"
          titleHighlight="à votre écoute"
          subtitle="Ils ne sont pas seulement formateurs, ils sont les architectes de votre carrière digitale."
        />
      </div>

      <ul v-if="team && team.length > 0" class="flex flex-wrap justify-center gap-8 list-none p-0 m-0">
        <li 
          v-for="(member, index) in team" 
          :key="index"
          class="w-[260px] max-w-full flex-none"
        >
           <SchoolTeamMemberCard 
             :member="member" 
             :index="index" 
             :is-visible="isVisible" 
             :is-flipped="flippedMemberId === (member.id || index)"
             @flip="toggleFlip(member.id || index)"
           />
        </li>
      </ul>
      <div v-else class="text-center py-20 transition-all duration-1000" :class="isVisible ? 'opacity-100' : 'opacity-0'">
        <p class="text-slate-500 dark:text-gray-400 text-xl font-light italic">
          Ils sont en cours de chargement... <br/>
          <span class="text-sm opacity-50">L'équipe arrive bientôt !</span>
        </p>
      </div>
    </div>
  </section>
</template>

<style scoped>
.animate-bounce-slow {
    animation: bounce-slow 2s infinite;
}
</style>

